// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"153":"analytics","539":"achievements","954":"achievements-ui"}[chunkId] || chunkId) + "." + {"140":"04ba5eeb","153":"3974a84d","188":"46b96ca8","233":"7e48c556","331":"e151afe2","397":"239f627b","539":"bf52548f","729":"12720b88","954":"c43cb9e9"}[chunkId] + ".chunk.js";
};